export const FACTORING_COMPANY_DETAILS_CHANGE_TRACKING = {
  factoringCompanyDetailsContact: {
    source: 'factoring_company_details.contact',
    id: 15001,
  },
  factoringCompanyDetailsDetails: {
    source: 'factoring_company_details.details',
    id: 15002,
  },
  factoringCompanyDetailsMailingAddress: {
    source: 'factoring_company_details.mailing_address',
    id: 15005,
  },
  factoringCompanyDetailsPhysicalAddress: {
    source: 'factoring_company_details.physical_address',
    id: 15006,
  },
  factoringCompanyDetailsPortalLogin: {
    source: 'factoring_company_details.portal_login',
    id: 15007,
  },
  factoringCompanyDetailsCreate: {
    source: 'factoring_company_details.create',
    id: 15101,
  },
  factoringCompanyDetailsDelete: {
    source: 'factoring_company_details.delete',
    id: 15102,
  },
  factoringCompanyDetailsDocumentsDelete: {
    source: 'factoring_company_details.documents.delete',
    id: 15103,
  },
  factoringCompanyDetailsDocumentsUpload: {
    source: 'factoring_company_details.documents.upload',
    id: 15104,
  },
  factoringCompanyDetailsInternalNotesAdd: {
    source: 'factoring_company_details.internal_notes.add',
    id: 15105,
  },
  factoringCompanyDetailsInternalNotesDelete: {
    source: 'factoring_company_details.internal_notes.delete',
    id: 15106,
  },
} as const;
